jQuery(document).ready(function($) {
 

  $('.performance_slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: true,
    variableWidth: false,
    centerMode: false,

    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          variableWidth: false,
          centerMode: false
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: false,
          centerMode: false
        }
      }
    ]
  });

});






document.addEventListener("DOMContentLoaded",()=>{

const brands=document.querySelectorAll(".vehicle-brand");

const modelGroups=document.querySelectorAll(".vehicle-model-group");

const yearGroups=document.querySelectorAll(".vehicle-year-group");

brands.forEach((brand,brandIndex)=>{

brand.addEventListener("mouseenter",()=>{

brands.forEach(b=>b.classList.remove("active"));

brand.classList.add("active");

modelGroups.forEach(g=>g.classList.remove("active"));

if(modelGroups[brandIndex])

modelGroups[brandIndex].classList.add("active");

yearGroups.forEach(g=>g.classList.remove("active"));

});

});

document.querySelectorAll(".vehicle-model").forEach((model)=>{

model.addEventListener("mouseenter",()=>{

document.querySelectorAll(".vehicle-model").forEach(m=>m.classList.remove("active"));

model.classList.add("active");

const brand=model.closest(".vehicle-model-group").dataset.brand;

const modelIndex=model.dataset.model;

yearGroups.forEach(group=>{

group.classList.remove("active");

if(group.dataset.brand===brand && group.dataset.model===modelIndex){

group.classList.add("active");

}

});

});

});

});


(function () {
  const menu = document.querySelector('div[data-menu-grid-id="MegaMenuList-5"]');

  if (!menu) return;

  const columns = menu.querySelectorAll('.mega-menu__column');

  columns.forEach((column) => {
    const parentLink = column.querySelector('.mega-menu__link--parent');
    const subMenu = column.querySelector('ul');

    if (!parentLink || !subMenu) return;

    subMenu.addEventListener('mouseenter', () => {
      parentLink.classList.add('is-active');
    });

    subMenu.addEventListener('mouseleave', () => {
      parentLink.classList.remove('is-active');
    });
  });
})();

document.addEventListener('DOMContentLoaded', function () {
  const source =
    document.querySelector('[data-build-gallery]') ||
    document.querySelector(
      '.ai-build-gallery-template--27028224671787productbulidsgafedyzx'
    );
  const target = document.querySelector('.more_builds');

  if (source && target) {
    target.innerHTML = source.innerHTML;
      const currentState = source.getAttribute('data-state');
    if (currentState) {
      target.setAttribute('data-state', currentState);
      if (currentState === 'hidden') {
        target.style.setProperty('display', 'none', 'important');
      } else if (currentState === 'ready') {
        target.style.display = '';
      }
    }
  }
});

document.addEventListener('DOMContentLoaded', function () {

  function buildFrequentlyBoughtTogether() {

    const products = document.querySelectorAll(
      '.cbb-frequently-bought-product'
    );

    const selectors = document.querySelectorAll(
      '.cbb-frequently-bought-selector-list > li'
    );

    if (!products.length || !selectors.length) {
      return;
    }

    products.forEach(function (product, index) {

      const selectorItem = selectors[index];

      if (!selectorItem) return;

      /* Prevent duplicate rendering */
      if (product.querySelector('.dk-fbt-info')) {
        return;
      }

      /* -----------------------------------------
         GET PRODUCT TITLE
         ----------------------------------------- */

      const titleElement = selectorItem.querySelector(
        '.cbb-frequently-bought-selector-label-name'
      );

      let title = '';

      if (titleElement) {
        title = titleElement.textContent
          .replace('This item:', '')
          .trim();
      }


      /* -----------------------------------------
         GET PRICE
         ----------------------------------------- */

      const priceElement = selectorItem.querySelector(
        '.cbb-frequently-bought-selector-label-regular-price .money'
      );

      let price = '';

      if (priceElement) {
        price = priceElement.textContent.trim();
      }


      /* -----------------------------------------
         GET VARIANT SELECT
         ----------------------------------------- */

      const originalSelect = selectorItem.querySelector(
        '.cbb-recommendations-variant-select'
      );


      /* -----------------------------------------
         CREATE INFO WRAPPER
         ----------------------------------------- */

      const info = document.createElement('div');

      info.className = 'dk-fbt-info';


      /* PRODUCT TITLE + PRICE */

      const productTitle = document.createElement('div');

      productTitle.className = 'dk-fbt-title';

      productTitle.textContent =
        title + (price ? ' | ' + price : '');

      info.appendChild(productTitle);


      /* -----------------------------------------
         VARIANT DROPDOWN
         ----------------------------------------- */

      if (originalSelect) {

        const label = document.createElement('div');

        label.className = 'dk-fbt-label';

        label.textContent = 'BADGE & CAP COLOR';

        info.appendChild(label);


        const select = document.createElement('select');

        select.className = 'dk-fbt-select';


        /* COPY OPTIONS */

        Array.from(originalSelect.options).forEach(function (option) {

          const newOption = document.createElement('option');

          newOption.value = option.value;

          newOption.textContent = option.textContent;

          newOption.dataset.variantId =
            option.dataset.variantId || '';

          select.appendChild(newOption);

        });


        /* KEEP ORIGINAL VALUE */

        select.value = originalSelect.value;


        /* SYNC BACK TO APP */

        select.addEventListener('change', function () {

          originalSelect.value = this.value;

          originalSelect.dispatchEvent(
            new Event('change', {
              bubbles: true
            })
          );

        });


        info.appendChild(select);

      }


      /* -----------------------------------------
         CHECKBOX
         ----------------------------------------- */

      const originalCheckbox = selectorItem.querySelector(
        '.cbb-frequently-bought-selector-input'
      );

      if (originalCheckbox) {

        const checkbox = document.createElement('input');

        checkbox.type = 'checkbox';

        checkbox.className = 'dk-fbt-check';

        checkbox.checked = originalCheckbox.checked;


        /* SYNC TO ORIGINAL */

        checkbox.addEventListener('change', function () {

          originalCheckbox.checked = this.checked;

          originalCheckbox.dispatchEvent(
            new Event('change', {
              bubbles: true
            })
          );

        });


        product.appendChild(checkbox);
      }


      /* ADD CARD INFO */

      product.appendChild(info);

    });


    /* -----------------------------------------
       HIDE ORIGINAL APP SELECTOR CONTENT
       ----------------------------------------- */

    const selectorList = document.querySelector(
      '.cbb-frequently-bought-selector-list'
    );

    if (selectorList) {
      selectorList.style.display = 'none';
    }

  }


  /* Initial */
  buildFrequentlyBoughtTogether();


  /* App can render dynamically */
  const observer = new MutationObserver(function () {

    buildFrequentlyBoughtTogether();

  });


  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

});

/* ==========================================================================
   DYNAMIC "SHOP BY VEHICLE" TRIGGER FOR DESKTOP & MOBILE
   Triggers when clicking any link with #shop-by-vehicle or #shop-by-vehical,
   or when opening any page with that hash in the URL.
   ========================================================================== */
(function () {
  function isVehicleHash(hash) {
    if (!hash) return false;
    const cleanHash = hash.replace(/^#/, '').toLowerCase();
    return cleanHash === 'shop-by-vehicle' || cleanHash === 'shop-by-vehical';
  }

  function openShopByVehicle() {
    // 1. Smoothly scroll to the top of the page
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });

    const isMobile = window.innerWidth < 990;

    if (!isMobile) {
      /* ----------------------------------------------------
         DESKTOP: Open Header Mega Menu Dropdown
         ---------------------------------------------------- */
      const headerMenu = document.querySelector('header-menu');
      const vehicleSubmenu = document.querySelector('.menu-list__submenu--vehicle');
      const vehicleItem = vehicleSubmenu ? vehicleSubmenu.closest('.menu-list__list-item') : null;
      const vehicleLink = vehicleItem ? vehicleItem.querySelector('.menu-list__link') : null;

      if (vehicleSubmenu && vehicleItem && vehicleLink && headerMenu) {
        // Trigger theme component native pointerenter/focus
        vehicleItem.dispatchEvent(new PointerEvent('pointerenter', { bubbles: true }));
        vehicleLink.dispatchEvent(new FocusEvent('focus', { bubbles: true }));

        // Ensure aria and calculated height are applied
        requestAnimationFrame(() => {
          const height = vehicleSubmenu.scrollHeight || vehicleSubmenu.offsetHeight || 500;
          headerMenu.setAttribute('aria-expanded', 'true');
          vehicleLink.setAttribute('aria-expanded', 'true');
          vehicleItem.setAttribute('aria-expanded', 'true');
          headerMenu.style.setProperty('--submenu-height', `${height}px`);
        });

        // Close cleanly if user clicks anywhere outside the menu
        const closeOnOutsideClick = function (e) {
          if (!e.target.closest('header-menu') && !e.target.closest('a[href*="shop-by-vehicle"], a[href*="shop-by-vehical"]')) {
            headerMenu.removeAttribute('aria-expanded');
            vehicleLink.removeAttribute('aria-expanded');
            vehicleItem.removeAttribute('aria-expanded');
            headerMenu.style.setProperty('--submenu-height', '0px');
            document.removeEventListener('click', closeOnOutsideClick);
          }
        };
        setTimeout(() => {
          document.addEventListener('click', closeOnOutsideClick);
        }, 100);
      }
    } else {
      /* ----------------------------------------------------
   MOBILE (< 990px): Open Custom DKNAV Drawer
   & Shop By Vehicle Panel
   ---------------------------------------------------- */

const drawer = document.querySelector('#DknavDrawer');
const drawerOpenButton = document.querySelector('[data-dknav-m-open]');
const vehicleButton = drawer?.querySelector('[data-dknav-to="vehicle"]');

if (drawer && vehicleButton) {

  // Open the mobile drawer first if it is closed
  const isDrawerOpen = drawer.getAttribute('aria-hidden') !== 'true';

  if (!isDrawerOpen && drawerOpenButton) {
    drawerOpenButton.click();
  }

  // Give the drawer a moment to open
  setTimeout(() => {
    const currentVehicleButton =
      drawer.querySelector('[data-dknav-to="vehicle"]');

    if (currentVehicleButton) {
      currentVehicleButton.click();
    }
  }, 150);
}
    }
  }

  // Handle click on any link or button pointing to #shop-by-vehicle or #shop-by-vehical
  document.addEventListener('click', function (e) {
    const link = e.target.closest('a[href*="shop-by-vehicle"], a[href*="shop-by-vehical"], [data-trigger="shop-by-vehicle"]');
    if (!link) return;

    const href = link.getAttribute('href') || '';
    const hash = href.includes('#') ? href.split('#')[1] : '';

    if (isVehicleHash(hash)) {
      // If link is strictly on the current page (#...), prevent default page jump
      if (href.startsWith('#') || href === window.location.pathname + '#' + hash) {
        e.preventDefault();
      }
      openShopByVehicle();
    }
  });

  // Handle direct page load or refresh with #shop-by-vehicle in the URL
  function checkUrlHashOnLoad() {
    if (isVehicleHash(window.location.hash)) {
      setTimeout(openShopByVehicle, 400);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkUrlHashOnLoad);
  } else {
    checkUrlHashOnLoad();
  }

  window.addEventListener('hashchange', function () {
    if (isVehicleHash(window.location.hash)) {
      openShopByVehicle();
    }
  });
})();


// hero video banner
document.addEventListener('DOMContentLoaded', function () {

  const counters = document.querySelectorAll('.counter');

  counters.forEach(counter => {

    const target = parseInt(counter.dataset.count);
    const duration = 2000;
    const stepTime = 20;
    const increment = target / (duration / stepTime);

    let current = 0;

    const updateCounter = () => {
      current += increment;

      if (current >= target) {
        current = target;

        if (target >= 1000) {
          counter.textContent = Math.round(target / 1000) + 'K+';
        } else {
          counter.textContent = target + '+';
        }

        return;
      }

      if (target >= 1000) {
        counter.textContent = Math.floor(current / 1000) + 'K+';
      } else {
        counter.textContent = Math.floor(current);
      }

      requestAnimationFrame(updateCounter);
    };

    updateCounter();

  });

});

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.inner_banner_area .dk-banner-title').forEach(function (title) {
    const text = title.textContent.trim();

    // Detect year range like 2004-2008
    const match = text.match(/^(\d{4}-\d{4})\s+(.+)$/);

    if (match) {
      title.innerHTML = match[1] + '<br>' + match[2];
    }
  });
});
 
 